import { Component, OnDestroy, OnInit } from "@angular/core"

import { Title } from "@angular/platform-browser"
import { ActivatedRoute, Params, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { CHNode } from "../models/node.model"
import { PBSLM_TITLE } from "../models/constants"
import { BrowsingService } from "../services/browsing.service"
import { ColorCodeService } from "../services/color-code.service"
import { TruncatePipe } from "../shared-components/pipes/truncate.pipe"
import { redirectToError } from "../utils/error-handling"
import { UserService } from "../services/user.service"

@Component({
    selector: "app-browsing",
    templateUrl: "./browsing.component.html",
    styleUrls: ["./browsing.component.scss"],
})
export class BrowsingComponent implements OnInit, OnDestroy {
    public nodeDepth: number = 0
    public resultsPerRow: number = 3
    public bannerBg: string = ""
    public subscriptions: Subscription[] = []
    public activeNode: CHNode
    public colorCode: string = "#fff"

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private router: Router,
        private colorCodeService: ColorCodeService,
        private titleService: Title,
        private truncatePipe: TruncatePipe,
        public userService: UserService
    ) {
        this.titleService.setTitle(PBSLM_TITLE)
        this.colorCode = this.colorCodeService.getPrimaryColor()
    }

    public ngOnInit() {
        this.subscriptions.push(this.browsingService.getSubjectsTree().subscribe())
        this.subscriptions.push(
            this.browsingService.invalidNodeSelected.subscribe(() => {
                redirectToError(this.router, "404")
            })
        )
        this.subscriptions.push(
            this.route.params.subscribe((params: Params) => {
                this.browsingService.selectNode(params.nodeSlug)
            })
        )
        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe((node: CHNode) => {
                if (!node.isLoaded()) {
                    return
                }
                this.browsingService.breadcrumbs = []
                this.bannerBg = node.banner
                this.activeNode = node
                this.colorCode = this.colorCodeService.getColorForNode(node)
                if (this.activeNode.title) {
                    const title = this.truncatePipe.transform(this.activeNode.title, 250)
                    const metaTitle = this.truncatePipe.transform(this.activeNode.metaTitle, 200)
                    const titleWithoutHtml = metaTitle || title
                    this.titleService.setTitle(titleWithoutHtml)
                }
                this.nodeDepth = node.getDepth()
                this.resultsPerRow = this.nodeDepth > 1 ? 3 : 4
            })
        )
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
